import api from "../../../lib/api";

export default {
  postComment(data) {
    return api({
      endpoint: "comments",
      path: "contents",
      method: "POST",
      body: data
    });
  },
  getCommentList(data) {
    return api({
      endpoint: "comments",
      path: "contents",
      method: "GET",
      queryParams: data
    });
  },
  deleteComment(data) {
    return api({
      endpoint: "comments",
      path: "contents",
      method: "DELETE",
      id: data
    });
  },
  postReportComment(data) {
    return api({
      endpoint: "report-comment",
      path: "problem-report",
      method: "POST",
      body: data
    });
  },
  postReportContents(data) {
    return api({
      endpoint: "report-contents",
      path: "problem-report",
      method: "POST",
      body: data
    });
  },
  getCommentOriginalText(data) {
    return api({
      endpoint: "comments/original-text",
      path: "translations",
      method: "GET",
      queryParams: data
    });
  },
  getCommentTranslatedText(data) {
    return api({
      endpoint: "comments/translated-text",
      path: "translations",
      method: "GET",
      queryParams: data
    });
  },
  postAddGood(data) {
    return api({
      endpoint: "register",
      path: "favorite",
      method: "POST",
      body: data
    });
  },
  getContentsOriginalText(data) {
    return api({
      endpoint: "contents/original-text",
      path: "translations",
      method: "GET",
      queryParams: data
    });
  },
  getContentsTranslatedText(data) {
    return api({
      endpoint: "contents/translated-text",
      path: "translations",
      method: "GET",
      queryParams: data
    });
  },
  postContentsSecretWord(data) {
    return api({
      endpoint: "contents-reading-authorizations",
      path: "contents",
      method: "POST",
      body: data
    });
  },
  postRatingAgreements(data) {
    return api({
      endpoint: "contents-rating-agreements",
      path: "contents",
      method: "POST",
      body: data
    });
  },
  getContentsDetailInfo(data) {
    return api({
      endpoint: "contents-detail-info",
      path: "contents",
      method: "GET",
      queryParams: data
    });
  },
  postStar(data) {
    return api({
      endpoint: "stars",
      path: "starred",
      method: "POST",
      body: data
    });
  },
  deleteStar(data) {
    return api({
      endpoint: "stars",
      path: "starred",
      method: "DELETE",
      queryParams: data
    });
  }
};
